import { render, staticRenderFns } from "./ModalDocumentoIBP.vue?vue&type=template&id=ab2e9798"
import script from "./ModalDocumentoIBP.vue?vue&type=script&lang=js"
export * from "./ModalDocumentoIBP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports